import { InsertRowLeftOutlined, UndoOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Popconfirm,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
import qr from "../../image/qr.png";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import { ReactComponent as ArchiveButtonicon } from "../../image/ArchiveButtonicon.svg";

import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { confirmAlert } from "react-confirm-alert";
import QRCode from "qrcode";
const PickupPoint = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pickupPointList, setpickupPointList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const { Option } = Select;
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getpickupPointList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("pickup-point/", state);

        if (apiResponse?.data?.results?.success) {
          setpickupPointList(apiResponse?.data?.results?.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_pickuppoint_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getpickupPointList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "additional_detail" && sortOrder === "ascend") {
      sortingEnumKey = "additional_detail";
    }
    if (sortField === "additional_detail" && sortOrder === "descend") {
      sortingEnumKey = "-additional_detail";
    }
    if (sortField === "pincode" && sortOrder === "ascend") {
      sortingEnumKey = "pincode";
    }
    if (sortField === "pincode" && sortOrder === "descend") {
      sortingEnumKey = "-pincode";
    }

    if (sortField === "suburb" && sortOrder === "ascend") {
      sortingEnumKey = "suburb";
    }
    if (sortField === "suburb" && sortOrder === "descend") {
      sortingEnumKey = "-suburb";
    }
    if (sortField === "latitude" && sortOrder === "ascend") {
      sortingEnumKey = "latitude";
    }
    if (sortField === "latitude" && sortOrder === "descend") {
      sortingEnumKey = "-latitude";
    }
    if (sortField === "longitude" && sortOrder === "ascend") {
      sortingEnumKey = "longitude";
    }
    if (sortField === "longitude" && sortOrder === "descend") {
      sortingEnumKey = "-longitude";
    }
    if (sortField === "address" && sortOrder === "ascend") {
      sortingEnumKey = "address";
    }
    if (sortField === "address" && sortOrder === "descend") {
      sortingEnumKey = "-address";
    }

    if (sortField === "phone" && sortOrder === "ascend") {
      sortingEnumKey = "phone";
    }
    if (sortField === "phone" && sortOrder === "descend") {
      sortingEnumKey = "-phone";
    }

    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }
    if (sortField === "person_name" && sortOrder === "ascend") {
      sortingEnumKey = "person_name";
    }
    if (sortField === "person_name" && sortOrder === "descend") {
      sortingEnumKey = "-person_name";
    }
    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state";
    }
    return sortingEnumKey;
  };

  const handleQRDownload = async (secretKey) => {
    try {
      // Generate QR code as a data URL (base64 PNG)
      const dataUrl = await QRCode.toDataURL(secretKey, {
        width: 300, // Set width
        margin: 2, // Set margin
      });

      // Create a link to trigger the download
      const downloadLink = document.createElement("a");
      downloadLink.href = dataUrl;
      downloadLink.download = "QRCode.png"; // File name
      downloadLink.click();
    } catch (err) {
      console.error("Error generating QR code:", err);
    }
  };
  // const handleQRDownload = async (secretKey) => {
  //   const endpoint = `pickup-point/download-qr-code/`;
  //   const fileType = "png"; // File type for QR code

  //   const payload = {
  //     uniq_id: secretKey,
  //   };

  //   try {
  //     const response = await postRequest(endpoint, payload);

  //     // Check if response contains Base64 string or binary data
  //     if (
  //       typeof response.data === "string" &&
  //       response.data.startsWith("data:image")
  //     ) {
  //       // Base64 image string
  //       const link = document.createElement("a");
  //       link.href = response.data;
  //       link.download = `QRCode_${secretKey}.${fileType}`;
  //       link.click();
  //     } else {
  //       // Handle binary data
  //       const blob = new Blob([response.data], { type: `image/${fileType}` });
  //       const link = document.createElement("a");
  //       link.href = window.URL.createObjectURL(blob);
  //       link.download = `QRCode_${secretKey}.${fileType}`;
  //       link.click();
  //       window.URL.revokeObjectURL(link.href);
  //     }
  //   } catch (error) {
  //     console.error("Error downloading QR Code:", error);
  //   }
  // };

  const handleStatus = async (user_id, status) => {
    confirmAlert({
      title: t("confirmAlert_title"),
      message: t("pop_pickup_point_status_message"),
      buttons: [
        {
          label: t("confirmAlert_ok"),
          onClick: () => changeStatus(user_id, status),
        },
        {
          label: t("confirmAlert_cancel"),
          onClick: () => navigate("/pickup-point"),
        },
      ],
    });
  };

  const changeStatus = async (id, value) => {
    setLoading(true);
    await patchRequest(`pickup-point-status-change/${id}/`, { status: value })
      .then((response) => {
        SuccessNotificationMsg(t("status_updated_sucessfully"));
        // Use a function updater for setReload to reliably toggle the reload state
        setReload((prevReload) => !prevReload);
      })
      .catch((error) => {
        // Handle error here (e.g., show an error notification)
        console.error("Error updating status:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [checkedList, setCheckedList] = useState([
    "person_name",
    "email",
    "address",
    "phone",
    "suburb",
    "operation",
    "state",
    "pincode",
    "additional_detail",
    "status",
    "latitude",
    "longitude",
  ]);
  const [columns, setColumns] = useState([
    {
      title: "Name",
      dataIndex: "person_name",
      key: "person_name",
      sorter: true,
      width: 100,
      render: (dataIndex) => (
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textTransform: "none",
          }}
        >
          {dataIndex}
        </div>
      ),
    },

    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
      sorter: true,
      width: 200,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   // title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        //   title={
        //     <span style={{ color: "#fff" }}>{dataIndex?.toLowerCase()}</span>
        //   }
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textTransform: "lowercase",
          }}
        >
          {dataIndex?.toLowerCase()}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },

    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      width: 180,
      render: (phone) => {
        if (phone) {
          const cleanedPhone = String(phone).replace(/\D/g, "");

          if (cleanedPhone.startsWith("91")) {
            return `+91 ${cleanedPhone.slice(2, 7)} ${cleanedPhone.slice(7)}`;
          } else if (cleanedPhone.length > 5) {
            const countryCode = cleanedPhone.slice(0, cleanedPhone.length - 10);
            const localNumber = cleanedPhone.slice(-10);
            return `+${countryCode} ${localNumber.slice(
              0,
              5
            )} ${localNumber.slice(5)}`;
          } else {
            return `+${cleanedPhone}`;
          }
        }
        return null;
      },

      sorter: true,
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      sorter: true,
      width: 130,
    },
    {
      title: "Suburb",
      dataIndex: "suburb",
      key: "suburb",
      sorter: true,
      width: 130,
    },
    {
      title: "Latitude",
      dataIndex: "pickuppoint_coordinates",
      key: "latitude",
      sorter: true,
      render: (pickuppoint_coordinates) =>
        pickuppoint_coordinates?.latitude || "N/A",
      width: 150,
    },
    {
      title: "Longitude",
      dataIndex: "pickuppoint_coordinates",
      key: "longitude",
      sorter: true,
      render: (pickuppoint_coordinates) =>
        pickuppoint_coordinates?.longitude || "N/A",
      width: 150,
    },
    {
      title: "Pincode",
      dataIndex: "pincode",
      key: "pincode",
      sorter: true,
      width: 130,
    },
    {
      title: "Additional Detail",
      dataIndex: "additional_detail",
      key: "additional_detail",
      sorter: true,
      width: 130,
    },

    // {
    //   title: "Note",
    //   dataIndex: "company_note",
    //   key: "company_note",
    //   sorter: true,
    //   width: 130,
    //   render: (dataIndex) => (
    //     <Tooltip
    //       color={colors}
    //       placement="left"
    //       title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
    //     >
    //       <div
    //         style={{
    //           maxWidth: "400px",
    //           whiteSpace: "nowrap",
    //           overflow: "hidden",
    //           textOverflow: "ellipsis",
    //         }}
    //       >
    //         {dataIndex}
    //       </div>
    //     </Tooltip>
    //   ),
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      fixed: "right",
      width: 250,
      render: (e, record) => (
        <div className="SelectStatusSec">
          <Select
            value={e ? e : record.status}
            onChange={(e) => handleStatus(record.id, e)}
            defaultValue={e}
          >
            <Option value="Pending" disabled>
              {" "}
              <div className="discardopt">{t("pending")}</div>
            </Option>
            <Option value="Active">
              {" "}
              <div className="dealdoneopt">{t("active")}</div>
            </Option>
            <Option value="Inactive">
              {" "}
              <div className="contactedopt">{t("inactive")}</div>
            </Option>
          </Select>
        </div>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
          {/* <Tooltip
            color={colors}
            placement="left"
            title={<span style={{ color: "#fff" }}>Edit</span>}
          > */}
          <Link
            to={{
              pathname: "/pickup-point/edit/" + btoa(record.id),
            }}
          >
            <Editicon onClick={() => handleEdit(record.id)} />
          </Link>
          {/* </Tooltip> */}
          {/* <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Archive</span>}
          > */}
          <Popconfirm
            className="action"
            title={t("pop_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleArchive(record.id)}
          >
            <Archive style={{ cursor: "pointer" }} />
          </Popconfirm>
          {/* </Tooltip> */}
          {record?.status === "Active" ? (
            <>
              {/* <Tooltip
                color={colors}
                placement="right"
                title={<span style={{ color: "#fff" }}>Download QR</span>}
              > */}
              {/* {authUserData()?.permission.includes(
                  "employee|delete_employee"
                ) && ( */}
              <Popconfirm
                className="action"
                title={t("pop_title_qr")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                onConfirm={() => handleQRDownload(record?.uniq_id)}
              >
                <img src={qr} alt="QR" style={{ cursor: "pointer" }} />
              </Popconfirm>
              {/* )} */}
              {/* </Tooltip> */}
            </>
          ) : (
            ""
          )}
        </Space>
      ),
    },
  ]);

  useEffect(() => {
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList, columns]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  // const columnMenu = (
  //   <Menu>
  //     <Menu.Item>
  //       <Checkbox.Group
  //         value={checkedList}
  //         onChange={handleColumnVisibilityChange}
  //       >
  //         <Row>
  //           <Col span={12}>
  //             <Checkbox value="person_name">Name</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="email">E-mail</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="address">Address</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="phone">Phone</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="state">State</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="suburb">Suburb</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="pincode">Pincode</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="additional_detail">Additional Detail</Checkbox>
  //           </Col>

  //           <Col span={12}>
  //             <Checkbox value="operation" disabled>
  //               Action
  //             </Checkbox>
  //           </Col>
  //         </Row>
  //       </Checkbox.Group>
  //     </Menu.Item>
  //   </Menu>
  // );
  const allColumns = [
    { key: "person_name", title: "Name" },
    { key: "email", title: "E-mail" },
    { key: "address", title: "Address" },
    { key: "phone", title: "Phone" },
    { key: "state", title: "State" },
    { key: "suburb", title: "Suburb" },
    { key: "pincode", title: "postcode" },
    { key: "additional_detail", title: "Additional Detail" },
    { key: "operation", title: "Action" },
  ];

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            {allColumns.map((column) => (
              <Col span={12} key={column.key}>
                <Checkbox
                  value={column.key}
                  disabled={column.key === "operation"}
                >
                  {column.title}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const handleArchive = async (id = []) => {
    let ids = [...selectedRow];

    if (ids.length === 0 && id) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest(
        "pickup-point/archive-pickup-point/",
        {
          deleted: ids,
        }
      );
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("pickuppoint_archive_successfully"));

        setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };

  const handleEdit = (id) => {};

  const colors = ["#737373"];
  return (
    <>
    <div className="mainwrapper">
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & manage the list of company within the organization.
                </span>
              }
            > */}
            <h3>Pickup Point</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Pickup Point")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      // value={state.search}
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Add A New Company To The Organization&apos;s Database.
                </span>
              }
            > */}
            <Button
              className="BlueShadowBtn"
              type="primary"
              onClick={() => navigate("/pickup-point/add")}
              icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
            >
              {t("Add Pickup Point")}
            </Button>
            {/* </Tooltip> */}

            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={
                    <>
                      <div
                        className="BlueShadowBtn"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <ArchiveButtonicon />
                        <span>{t("pl_archive")}</span>
                      </div>
                    </>
                  }
                />
              </Popconfirm>
            )}
            {/* <Tooltip placement="topLeft" title="View Archived Records"> */}
            <Link className="Archiveicon" to="/pickup-point/archive">
              <Archiveicon />
            </Link>
            {/* </Tooltip> */}
            {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
            <div className="gridiconswrap">
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
            </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="Package-body">
          <div className="tablewrp">
          <Table
            rowSelection={rowSelection}
            columns={columns.filter((col) => !col.hidden)}
            rowKey={(record) => record.id}
            dataSource={pickupPointList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
            scroll={{
              x: 1000,
            }}
          />
        </div></div>
      </section>
      </div>
    </>
  );
};
export default PickupPoint;
